import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
    fetchNotifications as fetchNotificationsApi,
    markNotificationRead as markNotificationReadApi,
    markAllNotificationsRead as markAllNotificationsReadApi,
    deleteNotification as deleteNotificationApi,
} from "../../services/Notification";

export const fetchNotifications = createAsyncThunk(
    "notification/fetchNotifications",
    async (params = {}, { rejectWithValue }) => {
        try {
            const response = await fetchNotificationsApi(params);
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const markAsRead = createAsyncThunk(
    "notification/markAsRead",
    async (id, { rejectWithValue }) => {
        try {
            const response = await markNotificationReadApi(id);
            return { id, data: response };
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const markAllRead = createAsyncThunk(
    "notification/markAllRead",
    async (_, { rejectWithValue }) => {
        try {
            const response = await markAllNotificationsReadApi();
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const removeNotification = createAsyncThunk(
    "notification/removeNotification",
    async (id, { rejectWithValue }) => {
        try {
            await deleteNotificationApi(id);
            return id;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const notificationSlice = createSlice({
    name: "notification",
    initialState: {
        notifications: [],
        unreadCount: 0,
        totalCount: 0,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchNotifications.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchNotifications.fulfilled, (state, action) => {
                state.loading = false;
                state.notifications = action.payload.data || [];
                state.unreadCount = action.payload.meta?.unreadCount || 0;
                state.totalCount = action.payload.meta?.total || 0;
            })
            .addCase(fetchNotifications.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })
            .addCase(markAsRead.fulfilled, (state, action) => {
                const id = action.payload.id;
                const notif = state.notifications.find((n) => n.id === id);
                if (notif && !notif.isRead) {
                    notif.isRead = true;
                    state.unreadCount = Math.max(0, state.unreadCount - 1);
                }
            })
            .addCase(markAllRead.fulfilled, (state) => {
                state.notifications.forEach((n) => (n.isRead = true));
                state.unreadCount = 0;
            })
            .addCase(removeNotification.fulfilled, (state, action) => {
                const id = action.payload;
                const notif = state.notifications.find((n) => n.id === id);
                if (notif && !notif.isRead) {
                    state.unreadCount = Math.max(0, state.unreadCount - 1);
                }
                state.notifications = state.notifications.filter((n) => n.id !== id);
                state.totalCount = Math.max(0, state.totalCount - 1);
            });
    },
});

export default notificationSlice.reducer;
